import React from 'react';
import PropTypes from 'prop-types';
import './LoadingSpinner.css';

const LoadingSpinner = ({ fullPage = false, message = 'Loading...' }) => {
  return (
    <div className={`spinner-container ${fullPage ? 'spinner-container--full' : ''}`} role="status" aria-live="polite">
      <div className="spinner"></div>
      {message && <span className="spinner-text sr-only">{message}</span>}
    </div>
  );
};

LoadingSpinner.propTypes = {
  fullPage: PropTypes.bool,
  message: PropTypes.string
};

export default LoadingSpinner;
